import mitt from 'mitt'
import type { BufferChangeInfo } from './types'

export type Events = {
    OnBufferChanged: BufferChangeInfo
}

export const emitter = mitt<Events>()

export default emitter
